<section class="app-abo-us-pil" [id]="AboutUsSection.PILLARS">
  <div class="app-abo-us-pil__con container">
    <h2 class="app-abo-us-pil__con__h2">TRZY FILARY</h2>
  </div>

  <swiper-container
    [config]="swiperConfig"
    class="app-abo-us-pil__swi container"
    wwwSwiper
    init="false"
    (slideChange)="onSlideClick($event)"
  >
    @for (pillar of pillars; let i = $index; track i) {
      <swiper-slide class="app-abo-us-pil__swi__sl" swiperSlide>
        @if (activeSlideIndex() === i) {
          <img
            class="app-abo-us-pil__swi__sl__lef-img"
            [priority]="false"
            alt="Left image"
            [ngSrc]="pillar.leftImageSrc"
            width="392"
            height="519"
            [appAnimate]="'landing'"
            [speed]="'fast'"
          />
          <p class="app-abo-us-pil__swi__sl__des" [appAnimate]="'fadeIn'" [speed]="'fast'">
            {{ pillar.description }}
          </p>
          <!-- <img
            class="app-abo-us-pil__swi__sl__rig-img"
            [priority]="false"
            alt="Right image"
            [ngSrc]="pillar.rightImageSrc"
            width="389"
            height="525"
            [appAnimate]="'landing'"
            [speed]="'fast'"
          /> -->
        }
      </swiper-slide>
    }
  </swiper-container>
  <div class="app-abo-us-pil__swi__nav">
    <div class="app-abo-us-pil__swi__nav--prev"></div>
    <div class="app-abo-us-pil__swi__nav--pag"></div>
    <div class="app-abo-us-pil__swi__nav--next"></div>
  </div>
</section>
